export const validateAddAssetForm = (data) => {
  const errors = {};
  if (!data.date) errors.date = "Date is required";
  if (!data.amount || isNaN(data.amount) || Number(data.amount) <= 0)
    errors.amount = "Amount must be a positive number";
  if (!data.title) errors.title = "Title is required";
  if (!data.paymentmethod) errors.paymentmethod = "Payment method is required";
  if (!data.description) errors.description = "description is required";
  return errors;
};

export const validateSellAssetForm = (data) => {
  const errors = {};
  //   if (!data.soldinfo.title) errors.date = "title is required";
  if (!data.soldinfo.date) errors.date = "Sold date is required";
  if (
    !data.soldinfo.amount ||
    isNaN(data.soldinfo.amount) ||
    Number(data.soldinfo.amount) <= 0
  )
    errors.amount = "Amount must be a positive number";
  if (!data.soldinfo.paymentmethod)
    errors.paymentmethod = "Payment method is required";
  return errors;
};
